import gql from 'graphql-tag'

export const TRANSFER_OWNERSHIP = gql`
  mutation TransferOwnership {
    transferOwnership {
      transferredProjectsCount
    }
  }
`
